import { Badge } from '@/shared/components/ui/badge'

interface TicketStatusChipProps {
  status: {
    code: string
    name: string
    color?: string | null
    bg?: string | null
    isFinal: boolean
  }
}

/**
 * Chip del estado del ticket. Usa los colores del nomenclador del panel
 * (editables por el staff) si vienen definidos; si no, cae al Badge estándar.
 */
export function TicketStatusChip({ status }: TicketStatusChipProps) {
  if (status.color || status.bg) {
    return (
      <span
        className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium"
        style={{
          color: status.color ?? undefined,
          backgroundColor: status.bg ?? undefined,
        }}
      >
        {status.name}
      </span>
    )
  }
  return <Badge variant={status.isFinal ? 'inactive' : 'info'}>{status.name}</Badge>
}
